
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface ArticleListFilterProps {
  value: string;
  onChange: (value: string) => void;
}

export default function ArticleListFilter({ value, onChange }: ArticleListFilterProps) {
  return (
    <div className="w-48">
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="bg-black/20 border-white/10 text-white">
          <SelectValue placeholder="Filter by state" className="text-white" />
        </SelectTrigger>
        <SelectContent className="bg-[#18181b] border-white/10 text-white">
          <SelectItem value="all">All Articles</SelectItem>
          <SelectItem value="draft">Drafts</SelectItem>
          <SelectItem value="published">Published</SelectItem>
          <SelectItem value="archived">Archived</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
